export default __webpack_public_path__ + "static/media/02.2ae022dd.jpg";